// extracted by mini-css-extract-plugin
module.exports = {"root":"blog_text-module--root--3f50W","img":"blog_text-module--img--2s99T"};